// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"985ad984","764":"985ad984","781":"985ad984","846":"2a3b83c7"}[chunkId] + ".css";
};